import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './FacultyMemberInfo.module.scss';
import Buttons from '../../Atoms/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';
const FacultyMemberInfo = ({ data, handleOnClose, setShowDeletePopup }) => {
  const navigate = useNavigate();

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px', gap: '0px' }}
      closeStyle={{ top: '25px', right: '25px' }}
    >
      <div>
        {isEmpty(data?.facultyImage) ? (
          <img
            src={noImageFound}
            className={styles['modal-image']}
            style={{ height: '25vh' }}
          />
        ) : (
          <img
            src={sanitizeAndValidateUrl(`${data?.url}${data?.facultyImage}`)}
            className={styles['modal-image']}
          />
        )}
      </div>
      <div
        className={styles['info-container']}
        style={{ maxHeight: isEmpty(data?.facultyImage) ? '50vh' : '' }}
      >
        <div className={styles['row']}>
          <div>
            <p className={styles['key']}>الاسم</p>
            <p className={styles['value']}>{data?.fullName_AR}</p>
            <p className={styles['key']}>منصب</p>
            <p className={styles['value']}>
              {!isEmpty(data?.positionAR) ? data?.positionAR : '-'}
            </p>
            <p className={styles['key']}>الدرجة الأكاديمية</p>
            <p className={styles['value']}>
              {!isEmpty(data?.educationEN) ? data?.educationAR : '-'}
            </p>
            <p className={styles['key']}>اللغة</p>
            <p className={styles['value']}>
              {!isEmpty(data?.languagesAR) ? data?.languagesAR : '-'}
            </p>
            <p className={styles['key']}>البريد الإلكتروني</p>
            <p className={styles['value']}>
              {!isEmpty(data?.email) ? data?.email : '-'}
            </p>
          </div>
        </div>{' '}
      </div>
      <div className={styles['button-container']}>
        <Buttons
          text="تعديل"
          color="#0DA06E"
          rounded={true}
          style={{ width: '100%' }}
          type="submit"
          handleOnClick={() =>
            navigate(`/home/edit-faculty/${data?.facultyId}`)
          }
        />
        <Buttons
          text="حذف"
          color="#D72222"
          rounded={true}
          style={{ width: '100%' }}
          type="submit"
          handleOnClick={() => {
            handleOnClose();
            setShowDeletePopup(true);
          }}
        />
      </div>
    </Modal>
  );
};

export default FacultyMemberInfo;
